// Those files are saved on a new folder to prevent breaking changes
const DEFAULT_STYLE_ID = 'theme';

export { DEFAULT_STYLE_ID };
//# sourceMappingURL=constants.js.map
